import { Component, EventEmitter, inject, Input, Output } from '@angular/core';

import { Portals } from '@qwyk/models';
import { MD5Pipe, UrlEncodePipe } from '@qwyk/ui-standalone';

@Component({
    selector: 'qwyk-quotation-detail-header',
    templateUrl: './quotation-detail-header.component.html',
    styleUrls: ['./quotation-detail-header.component.scss'],
})
export class QuotationDetailHeaderComponent {
    private readonly md5 = inject(MD5Pipe);
    private readonly urlEncode = inject(UrlEncodePipe);

    @Input() quotation!: Portals.QuotationEntity;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Input() url!: any;
    @Input() busy = false;
    @Input() isPolling = false;
    @Input() isMasterAdmin = false;

    @Output() delete: EventEmitter<Portals.QuotationEntity> =
        new EventEmitter<Portals.QuotationEntity>();
    // eslint-disable-next-line @angular-eslint/no-output-native
    @Output() close: EventEmitter<Portals.QuotationEntity> =
        new EventEmitter<Portals.QuotationEntity>();
    @Output() download: EventEmitter<Portals.QuotationEntity> =
        new EventEmitter<Portals.QuotationEntity>();
    @Output() publish: EventEmitter<Portals.QuotationEntity> =
        new EventEmitter<Portals.QuotationEntity>();

    public readonly STATUS = {
        OPEN: 'open',
    };

    get isBusy(): boolean {
        return this.busy || this.isPolling;
    }

    get isDraft(): boolean {
        return this.quotation?.is_draft;
    }

    public get iconAnimation() {
        return this.busy ? 'pulse' : undefined;
    }

    public getAvatarUrl(user: { email: string; name: string }): string {
        const hash = this.md5.transform(user.email);
        const encodedName = this.urlEncode.transform(user.name);

        return `https://www.gravatar.com/avatar/${hash}?d=https%3A%2F%2Fui-avatars.com%2Fapi%2F/${encodedName}/24/097aff/ffffff/2//false/true/true`;
    }

    public showPopover(popover: any, event: Event) {
        popover.show(event);
    }

    public hidePopover(popover: any) {
        popover.hide();
    }
}
